// extracted by mini-css-extract-plugin
export default {"containerGlobal":"NewSaleScreen_containerGlobal__Soi5c","containerCenter":"NewSaleScreen_containerCenter__Zq35N"};